import { FC } from 'react';

// Components
import TeamDetails from './TeamDetails/TeamDetails';
import TeamImage from './TeamImage/TeamImage';
import { FormResults, SocialIconsList, Tournaments } from '../common';
import Image from '../../../../../../packages/HOC/AccessibilityImage';

// Hooks/Utils
import { defaultHandleEventClick, defaultHandleTeamClick } from '@sportal365/smp-widget-utils';

// Types
import { TeamInformation } from '../../../types';
import { ISubscriberInfo } from '../../../../../../packages/types';
import { TEAM_ENTITY } from '../../../../../../packages/constants/entityTypes';

interface Props {
  teamInformation: TeamInformation;
  handleClick: (info: ISubscriberInfo, clickType: string) => void;
  showSocialIcons: boolean;
  showTeamImage: boolean;
}

const TeamInformationHeader: FC<Props> = ({ teamInformation, handleClick, showSocialIcons, showTeamImage }) => {
  const { team, country, form, tournaments, social, urlTarget } = teamInformation;

  const handleTeamClick = () => defaultHandleTeamClick(handleClick, { ...team });

  const handleFormEventClick = (id: string | number) => defaultHandleEventClick(handleClick, id);

  return (
    <div className='team-information-wrapper flex justify-between flex-col tb:flex-row p-0 sm:pt-4 sm:px-4'>
      <div className='block sm:hidden'>
        <TeamImage squad_image={team.squad_image} showImage={showTeamImage} />
      </div>
      <div className='team-info-wrapper flex gap-4 max-h-[375px] items-center pt-4 px-4 sm:pt-0 sm:px-0'>
        <a href={team.url} target={urlTarget} onClick={handleTeamClick}>
          <Image
            src={team.image}
            alt={team.name}
            entityType={TEAM_ENTITY}
            className='team-image max-w-[65px] sm:max-w-[105px] max-h-[65px] sm:max-h-[105px]'
          />
        </a>
        <div className='team-details-container w-full'>
          <a href={team.url} target={urlTarget} onClick={handleTeamClick} className='no-underline'>
            <p className='team-name mx-0 mb-2 mt-0 font-bold text-hiContrast text-6 sm:text-[32px]'>{team.name}</p>
          </a>
          <TeamDetails name={country.name} founded={team.founded} stadium={team.stadium} />
          <div className='team-overview-desktop-container hidden tb:flex lg:gap-7 gap-2 mt-4'>
            <FormResults data={form} handleClick={handleFormEventClick} />
            <Tournaments tournaments={tournaments} handleClick={handleClick} />
          </div>
        </div>
      </div>
      <div className='player-overview-mobile-container flex justify-between tb:hidden gap-4 pt-4 flex-col-reverse xs:flex-row px-4 sm:px-0'>
        <FormResults data={form} handleClick={handleFormEventClick} />
        <Tournaments tournaments={tournaments} handleClick={handleClick} />
      </div>
      <div className='block tb:py-0 py-4 lg:hidden align-bottom self-stretch tb:self-end px-4 sm:px-0'>
        {social && <SocialIconsList data={social} showSocialIcons={showSocialIcons} />}
      </div>
      <div className='team-squad-image-wrapper hidden lg:block max-w-[375px]'>
        <TeamImage squad_image={team.squad_image} showImage={showTeamImage} />
        {social && <SocialIconsList data={social} showSocialIcons={showSocialIcons} />}
      </div>
    </div>
  );
};

export default TeamInformationHeader;
